// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filtered-receipts-container {
  padding: 2px;
  padding-bottom: 100px;
  margin: auto;
  background-color: #f9fafb;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  font-family: 'Segoe UI', sans-serif;
}

.filtered-receipts-title {
  font-size: 1.75rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 1.5rem;
  color: #1f2937;
}

.filtered-receipts-controls {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 1.25rem;
  gap: 1rem;
}

.filtered-receipts-date-picker label {
  font-size: 0.95rem;
  color: #374151;
  margin-right: 1rem;
}

.filtered-receipts-status-filter {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.status-chip {
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  background-color: #e5e7eb;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s ease-in-out;
}

.status-chip.active {
  background-color: #6366f1;
  color: white;
  font-weight: 500;
  box-shadow: 0 0 0 2px #c7d2fe;
}

.status-chip:hover {
  background-color: #d1d5db;
}

.filtered-receipts-columns {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
}

.filtered-receipts-columns label {
  font-size: 0.85rem;
  color: #4b5563;
  cursor: pointer;
}

.filtered-receipts-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 8px;
  margin-bottom: 1.5rem;
}

.filtered-receipts-table thead th {
  text-align: left;
  padding: 0.6rem 0.8rem;
  font-weight: 600;
  color: #374151;
  background-color: #f3f4f6;
  border-radius: 6px;
  -webkit-user-select: none;
          user-select: none;
}

.filtered-receipts-table tbody td {
  padding: 0.6rem 0.8rem;
  background-color: #ffffff;
  border-radius: 6px;
  font-size: 0.9rem;
  color: #1f2937;
  transition: background-color 0.2s ease;
}

.filtered-receipts-table tbody tr:hover td {
  background-color: #f9fafb;
}

.filtered-receipts-table .status {
  font-weight: bold;
  padding: 0.3rem 0.5rem;
  border-radius: 5px;
  color: white;
  text-align: center;
}

.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}

.pagination-controls button {
  padding: 0.4rem 1rem;
  border-radius: 8px;
  border: none;
  background-color: #4f46e5;
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.pagination-controls button:disabled {
  background-color: #d1d5db;
  cursor: default;
}

.pagination-controls span {
  font-size: 0.95rem;
  color: #374151;
}

  .table-scroll-wrapper {
  width: 100%;
}

.filtered-receipts-table {
  min-width: 1000px; /* можно подбирать значение */
}`, "",{"version":3,"sources":["webpack://./src/modules/Dispatcher/Undelivered/FilteredReceiptsTable.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;EAEE;EACA,WAAW;AACb;;AAEA;EACE,iBAAiB,EAAE,6BAA6B;AAClD","sourcesContent":[".filtered-receipts-container {\r\n  padding: 2px;\r\n  padding-bottom: 100px;\r\n  margin: auto;\r\n  background-color: #f9fafb;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);\r\n  font-family: 'Segoe UI', sans-serif;\r\n}\r\n\r\n.filtered-receipts-title {\r\n  font-size: 1.75rem;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  margin-bottom: 1.5rem;\r\n  color: #1f2937;\r\n}\r\n\r\n.filtered-receipts-controls {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 1.25rem;\r\n  gap: 1rem;\r\n}\r\n\r\n.filtered-receipts-date-picker label {\r\n  font-size: 0.95rem;\r\n  color: #374151;\r\n  margin-right: 1rem;\r\n}\r\n\r\n.filtered-receipts-status-filter {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  align-items: center;\r\n}\r\n\r\n.status-chip {\r\n  padding: 0.4rem 0.8rem;\r\n  border-radius: 20px;\r\n  background-color: #e5e7eb;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.status-chip.active {\r\n  background-color: #6366f1;\r\n  color: white;\r\n  font-weight: 500;\r\n  box-shadow: 0 0 0 2px #c7d2fe;\r\n}\r\n\r\n.status-chip:hover {\r\n  background-color: #d1d5db;\r\n}\r\n\r\n.filtered-receipts-columns {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 1rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.filtered-receipts-columns label {\r\n  font-size: 0.85rem;\r\n  color: #4b5563;\r\n  cursor: pointer;\r\n}\r\n\r\n.filtered-receipts-table {\r\n  width: 100%;\r\n  border-collapse: separate;\r\n  border-spacing: 0 8px;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.filtered-receipts-table thead th {\r\n  text-align: left;\r\n  padding: 0.6rem 0.8rem;\r\n  font-weight: 600;\r\n  color: #374151;\r\n  background-color: #f3f4f6;\r\n  border-radius: 6px;\r\n  user-select: none;\r\n}\r\n\r\n.filtered-receipts-table tbody td {\r\n  padding: 0.6rem 0.8rem;\r\n  background-color: #ffffff;\r\n  border-radius: 6px;\r\n  font-size: 0.9rem;\r\n  color: #1f2937;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.filtered-receipts-table tbody tr:hover td {\r\n  background-color: #f9fafb;\r\n}\r\n\r\n.filtered-receipts-table .status {\r\n  font-weight: bold;\r\n  padding: 0.3rem 0.5rem;\r\n  border-radius: 5px;\r\n  color: white;\r\n  text-align: center;\r\n}\r\n\r\n.pagination-controls {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.pagination-controls button {\r\n  padding: 0.4rem 1rem;\r\n  border-radius: 8px;\r\n  border: none;\r\n  background-color: #4f46e5;\r\n  color: white;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.pagination-controls button:disabled {\r\n  background-color: #d1d5db;\r\n  cursor: default;\r\n}\r\n\r\n.pagination-controls span {\r\n  font-size: 0.95rem;\r\n  color: #374151;\r\n}\r\n\r\n  .table-scroll-wrapper {\r\n  width: 100%;\r\n}\r\n\r\n.filtered-receipts-table {\r\n  min-width: 1000px; /* можно подбирать значение */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
